import { Component } from '@angular/core';

import { BadgeComponent } from '@camelot/ui';
import { Role } from '@camelot/user';

import { AbstractCellComponent } from '../../abstract';

@Component({
  host: { 'data-cid': 'grid-multi-role-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  template: `
    <div class="simple-flex align-center g-space-xs" style="height: 100%;">
      @for (value of this.value; track value.name) {
        <cam-badge [value]="value.name" class="d-flex"> </cam-badge>
      }
    </div>
  `,
  imports: [BadgeComponent],
})
export class GridMultiRoleCellComponent extends AbstractCellComponent<any, Role[]> {}
